module.exports = __webpack_public_path__ + "img/WhatsApp_black.6067740c.svg";